//所有有关用户信息的网络请求
import http from '../utils/http'
    
//不需要注册，直接登录
export function apiLogin(data){
    return http({
      url:'/user/profile/login',
      // url:'/profile/login',
      method:'POST',
      data
    })
}

//用户使用邮箱重置密码
export function apiForgotPass(data){
    return http({
      url:'/user/profile/link',
      method:'POST',
      data
    })
}

//重置密码
export function apiChangePass(data){
    return http({
      url:'/user/profile/update',
      method:'PUT',
      data
    })
}

//根据ID查询
export function apiUserinfo(id){
    return http({
      url:`/user/profile/${id}`,
      method:'get',
    })
}


//查询全部数据
export function apiAllUserinfo({page,size}){
  return http({
    url:`/user/profile/${page}/${size}`,
    method:'get',
  })
}

//新增
export function apiAddUserList(data){
  return http({
    url:'/user/profile',
    method:'POST',
    data
  })
}

//编辑
export function apiEditUserList(userId,data){
  return http({
    url:`/user/profile/${userId}`,
    method:'put',
    data:data
  })
}

//删除
export function apiDeleteUserList(id){
  return http({
    url:`/user/profile/${id}`,
    method:'delete',
  })
}

//根据条件多条件查询
export function apiUserSearch(params){
  return http({
    url:`/user/profile`,
    method:'GET',
    params: params,
  })
}













//用户注册时验证邮箱
// export function apiVerifyEmail(data){
//     return http({
//       url:'/apiuser/userprofile/verify',
//       method:'POST',
//       data
//     })
// }

// //用户注册
// export function apiRegister({code,mail,password,firstname,lastname,amazonProfileUrl,paypalAccount,socialPage,presentation,role}){
//   return http({
//     url:`/apiuser/userprofile/register/${code}`,
//     method:'POST',
//     data:{"mail":mail,
//     'password':password,
//     'firstname':firstname,
//     'lastname':lastname,
//     'amazonProfileUrl':amazonProfileUrl,
//     'paypalAccount':paypalAccount,
//     'socialPage':socialPage,
//     'presentation':presentation,
//     'role':role,
//     }
//   })
// }

// //用户登录
// export function apiLogin(data){
//   return http({
//     url:'/apiuser/userprofile/login',
//     method:'POST',
//     data
//   })
// }


// //用户忘记密码 获取邮箱链接
// export function apiForgot(data){
//   return http({
//     url:'/apiuser/userprofile/link',
//     method:'POST',
//     data
//   })
// }


// //邮箱链接点进去 改变密码页面
// export function apiChangePassword(data){
//   return http({
//     url:'/apiuser/userprofile/update',
//     method:'PUT',
//     data
//   })
// }
